import { Avatar } from '@mui/material';
import { indigo } from '@mui/material/colors';
import type { User } from 'app/collab/types';
import styled, { css } from 'styled-components';
import { getAvatarText } from '../../../common/avatars.js';

const ColorAvatar = styled(Avatar)<{ color: string; size: number }>`
  ${({ color, size, theme }) => css`
    height: ${size * 10}px;
    width: ${size * 10}px;
    font-size: ${(size * 10) / 1.5}px;
    font-weight: 500;
    color: ${theme.palette.getContrastText(color)};
    border: 2px solid ${color};
    background-color: ${color};
  `}
  & .initial {
    opacity: 0.8;
  }
`;

export type UserAvatarProps = {
  readonly user: User;
  readonly size?: number;
};

export function UserAvatar(props: UserAvatarProps) {
  const { user, size } = props;
  const name = user.fullName ?? user.email;
  const color = user.color ?? indigo[500];
  const initial = getAvatarText(name);
  return (
    <ColorAvatar alt={name} src={user.avatarPath} color={color} size={size ?? 3}>
      <span className="initial">{initial}</span>
    </ColorAvatar>
  );
}
